/**
 * Cliente API para autoedicion del vecino (Sprint 13 S13-32).
 *
 * PATCH /me/persona — el vecino edita SU propia persona, restringido
 * a email y celular. Otros campos requieren contactar a la Comision.
 */
import { apiFetch } from './client';

export interface AutoEdicionPersonaBody {
  email?: string | null;
  celular?: string | null;
}

export interface PersonaReadMinimal {
  id: string;
  nombre_completo: string;
  rut: string | null;
  email: string | null;
  celular: string | null;
  fecha_nacimiento: string | null;
  activo: boolean;
  es_test: boolean;
}

export function autoeditarPersona(
  data: AutoEdicionPersonaBody,
): Promise<PersonaReadMinimal> {
  return apiFetch<PersonaReadMinimal>('/me/persona', {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}
